<spa-alert [button]="button" [title]="title" [content]="content"></spa-alert>
